import produce from "immer"
import {
  CompletionFragment,
  CompletionFragmentDoc,
  DiscussionPostFragment
} from "@pathwright/graphql-client/src/generated"
import { getApolloClient } from "../../../pathwright/PathwrightClient"

// When discussion is created or response is created/deleted...
// 1) update the completion feedback_discussion_context
// 2) as a side-effect, this should update the feedbackReviewers query
export function updateFeedbackDiscussionNumResponses(
  discussion: DiscussionPostFragment,
  calcNumResponses?: (count: number) => number
) {
  if (!discussion?.step_id) return

  const client = getApolloClient()

  // Default to set num_responses to total_responses.
  calcNumResponses ||= () => discussion.total_responses || 0

  const fragment = {
    fragment: CompletionFragmentDoc,
    fragmentName: "Completion",
    id: `Completion:${discussion.step_id}`
  }

  const fragmentData = client.readFragment(fragment) as CompletionFragment

  const nextFragmentData = produce(fragmentData, (draft) => {
    if (!draft.feedback_discussion_context) {
      draft.feedback_discussion_context = {
        id: discussion.context_id,
        discussion_id: discussion.id,
        num_responses: 0
      }
    }

    draft.feedback_discussion_context.num_responses = calcNumResponses?.(
      draft.feedback_discussion_context.num_responses || 0
    )
  })
  client.writeFragment({
    ...fragment,
    data: nextFragmentData
  })
}
